import React from 'react';

import ArchiveOutlinedIcon from '@mui/icons-material/ArchiveOutlined';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import UnarchiveOutlinedIcon from '@mui/icons-material/UnarchiveOutlined';
import { Grid } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';

import DropdownCardMenu from 'common/components/DropdownCardMenu';

import * as actions from '../actions';

const MenuOptions = ({
    filterData,
    handleClickDuplicate,
    isArchived,
    prepareProposalArchive,
    prepareProposalDelete,
    proposalId,
    proposalName,
}) => {
    const { t } = useTranslation();

    return (
        <Grid size={{ xs: 3, lg: 2 }} textAlign="right">
            <DropdownCardMenu
                items={[
                    {
                        handleClick: () =>
                            handleClickDuplicate({
                                mode: 'rename',
                                projectId: filterData.projectId,
                                proposalId,
                                proposalName,
                            }),
                        icon: <EditIcon fontSize="small" />,
                        label: t('Rename'),
                    },
                    {
                        handleClick: () =>
                            handleClickDuplicate({
                                mode: 'duplicate',
                                projectId: filterData.projectId,
                                proposalId,
                                proposalName,
                            }),
                        icon: <FileCopyIcon fontSize="small" />,
                        label: t('Duplicate'),
                    },
                    {
                        handleClick: () =>
                            prepareProposalArchive(
                                filterData,
                                isArchived,
                                proposalId,
                                proposalName,
                                'archived',
                            ),
                        icon: <ArchiveOutlinedIcon fontSize="small" />,
                        label: t('Archive'),
                        visible: !isArchived,
                    },
                    {
                        handleClick: () =>
                            prepareProposalArchive(
                                filterData,
                                isArchived,
                                proposalId,
                                proposalName,
                                'active',
                            ),
                        icon: <UnarchiveOutlinedIcon fontSize="small" />,
                        label: t('Unarchive'),
                        visible: isArchived,
                    },
                    {
                        handleClick: () =>
                            prepareProposalDelete(
                                filterData,
                                proposalId,
                                proposalName,
                                'deleted',
                            ),
                        icon: <DeleteIcon fontSize="small" />,
                        label: t('Delete'),
                        visible: isArchived,
                    },
                ]}
                sxIconButton={{ mr: 1 }}
            />
        </Grid>
    );
};

const mapDispatchToProps = (dispatch) => ({
    prepareProposalArchive: (
        filterData,
        isArchived,
        proposalId,
        proposalName,
        value,
    ) =>
        dispatch(
            actions.prepareProposalArchive(
                filterData,
                isArchived,
                proposalId,
                proposalName,
                value,
            ),
        ),
    prepareProposalDelete: (filterData, proposalId, proposalName, value) =>
        dispatch(
            actions.prepareProposalDelete(
                filterData,
                proposalId,
                proposalName,
                value,
            ),
        ),
});

MenuOptions.propTypes = {
    filterData: PropTypes.object,
    handleClickDuplicate: PropTypes.func,
    isArchived: PropTypes.bool,
    prepareProposalArchive: PropTypes.func,
    prepareProposalDelete: PropTypes.func,
    proposalId: PropTypes.string,
    proposalName: PropTypes.string,
};

export default connect(null, mapDispatchToProps)(MenuOptions);
